// extracted by mini-css-extract-plugin
export var phone = "_32-0";
export var phoneDragging = "_32-1";